// SPDX-License-Identifier: AGPL-3.0-or-later

import * as AccessibilityCommands from '@app/features/accessibility/commands/AccessibilityCommands';
import Accessibility from '@app/features/accessibility/state/Accessibility';
import {Switch} from '@app/features/ui/components/form/Switch';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
import type React from 'react';
export const ChannelListTabContent: React.FC = observer(() => {
	const {t} = useLingui();
	return (
		<Switch
			label={t`Show unread indicator on muted channels`}
			description={t`When enabled, muted channels show a faded unread indicator on the left side. Mentions still appear regardless of this setting.`}
			value={Accessibility.showFadedUnreadOnMutedChannels}
			onChange={(value) => AccessibilityCommands.update({showFadedUnreadOnMutedChannels: value})}
		/>
	);
});
